// extracted by mini-css-extract-plugin
module.exports = {"leftNav":"left-nav-desktop-module--leftNav--1Cq69"};